import gql from 'graphql-tag';
export const QUERY = gql `
  query {
    me {
      username
      emailAddress
      firstName
      lastName
      enabled
      projects {
        id
        name
        apiUri
      }
    }
  }
`;
export async function fetchMeUser(client) {
    const meResponse = await client.query({ query: QUERY });
    return meResponse.data.me;
}
